enum FeatureCategoryCodes {
  BMW_ACCESSORIES = 'bmw_CHL_acc',
}

export default FeatureCategoryCodes;
